module.exports = __webpack_public_path__ + "static/img/RALZ_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RALZ_1.png
// module id = vwWD
// module chunks = 0